import SideBySideTextAndAssetComponent from "segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import TextAndProof from "./careers-text-and-proof-component";
import { StyledCareersHeroComponent } from "./careers-hero-component.scss";

export default function CareersHeroComponent({ isInternalMobilityPage, bestPlaceToWorkProps }) {
  const { title, subTitle } = getFirstFoldTexts();

  const titleAndImageSideBySideProps = {
    contentClassName: "side-by-side-title-and-image",
    leftSizeWidth: "40%",
    rightSizeWidth: "60%",
    fullParagraph: {
      topic: {
        text: "",
        image: {
          src: null
        }
      },
      title,
      body: "Come join us so together we can impact how teams work across the globe.",
      textAlign: "left",
      titleColor: "white"
    },
    asset: {
      position: "center",
      fitToContainer: true,
      image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/careers_site/cover_image.png"
      }
    },
    assetQuality: "q_auto",
    alignImageToScreenEdge: true
  };

  const proofAndSubtitleSideBySideProps = {
    contentClassName: "side-by-side-text-and-proof",
    leftSizeWidth: "40%",
    rightSizeWidth: "60%",
    replaceAssetComponent: FullParagraph,
    replaceAssetComponentProps: {
      topic: {
        text: "",
        image: {
          src: null
        }
      },
      title: "",
      body: subTitle,
      textAlign: "left",
      titleColor: "white",
      textWidth: "600px"
    },
    alignImageToScreenEdge: true,
    replaceTextComponent: TextAndProof,
    replaceTextComponentProps: bestPlaceToWorkProps
  };

  function getFirstFoldTexts() {
    if (isInternalMobilityPage) {
      return {
        title: "Grow with <br><strong>us</strong",
        subTitle:
          "We’re committed to helping you develop within your role, department, and the<br>company as a whole. Use this website to explore your potential growth<br>opportunities at monday.com.<br><br>See an open position that matches your skills? Check out our guidelines and apply!<br>Don’t fit the requirements? Visit our <a href='https://growth.monday.com' target='_blank' rel='noreferrer'>PDP website</a> to learn how to get there!",
      };
    }

    return {
      title: "Join the future <br>of work",
      subTitle:
        "monday.com is a Work OS that lets organizations manage all their work in one place. And like our platform, we are committed to building an organization with one shared mission. <br><br>We believe that the most effective teams are built on skills and passion, which is why in our recruitment process, in addition to learning about your background and experience, we really want to understand who you are and what empowers you.",
    };
  }

  return (
    <StyledCareersHeroComponent className="section hero section-hero" id="search-positions">
      <SideBySideTextAndAssetComponent {...titleAndImageSideBySideProps} />
      <SideBySideTextAndAssetComponent {...proofAndSubtitleSideBySideProps} />
    </StyledCareersHeroComponent>
  );
}
